import React, { useState } from "react";
import {
  Box,
  Flex,
  Text,
  Grid,
  Icon,
  Button,
  Collapse,
  useDisclosure,
  SimpleGrid,
  Heading,
  Stack,
} from "@chakra-ui/react";
import { GiWoodCabin } from 'react-icons/gi';
import {
  FaChild,
  FaUmbrellaBeach,
  FaCouch,
  FaDumbbell,
  FaSnowflake,
  FaParking,
  FaBath,
  FaSwimmingPool,
  FaTools,
  FaHouseUser,
  FaTree,
  FaConciergeBell,
  FaDoorOpen,
  FaWater,
  FaFire,
  FaClipboardCheck,
  FaCreditCard,
  FaCity,
  FaStreetView,
  FaUserFriends,
  FaUtensils,
  FaSubway,
  FaMosque,
  FaShoppingCart,
  FaLeaf,
  FaSpa,
  FaPenFancy,
  FaBuilding,
  FaChess,
  FaCar,
  FaEye,
  FaLocationArrow,
  FaBed,
  FaPlane,
  FaHospital,
  FaCompass,
  FaDog,
  FaHotTub,
  FaBox,
  FaBrush,
  FaCoffee,
  FaBlender,
  FaLock,
  FaHome,
} from "react-icons/fa";
import {
  MdCleaningServices,
} from "react-icons/md";
import { TbCurrencyDirham } from "react-icons/tb";
import { FormattedMessage, useIntl } from "react-intl";

const amenitiesMapping = {
  "balcony": { icon: FaUmbrellaBeach, label: <FormattedMessage id="amenity.balcony" defaultMessage="Balcony" /> },
  "built-in-wardrobes": { icon: FaCouch, label: <FormattedMessage id="amenity.builtInWardrobes" defaultMessage="Built-in Wardrobes" /> },
  "central-ac": { icon: FaSnowflake, label: <FormattedMessage id="amenity.centralAC" defaultMessage="Central A/C" /> },
  "private-jacuzzi": { icon: FaSwimmingPool, label: <FormattedMessage id="amenity.privateJacuzzi" defaultMessage="Private Jacuzzi" /> },
  "maid-room": { icon: FaUserFriends, label: <FormattedMessage id="amenity.maidRoom" defaultMessage="Maid Room" /> },
  "maids-room": { icon: FaUserFriends, label: <FormattedMessage id="amenity.maidRoom" defaultMessage="Maid Room" /> },
  "marble-floors": { icon: FaBath, label: <FormattedMessage id="amenity.marbleFloors" defaultMessage="Marble Floors" /> },
  "shared-swimming-pool": { icon: FaSwimmingPool, label: <FormattedMessage id="amenity.swimmingPool" defaultMessage="Shared Swimming Pool" /> },
  "security": { icon: FaLock, label: <FormattedMessage id="amenity.security" defaultMessage="Security" /> },
  "maintenance": { icon: FaTools, label: <FormattedMessage id="amenity.maintenance" defaultMessage="Maintenance" /> },
  "near-supermarket": { icon: FaHouseUser, label: <FormattedMessage id="amenity.nearSupermarket" defaultMessage="Near Supermarket" /> },
  "near-mall": { icon: FaCity, label: <FormattedMessage id="amenity.nearMall" defaultMessage="Near Mall" /> },
  "concierge": { icon: FaConciergeBell, label: <FormattedMessage id="amenity.conciergeService" defaultMessage="Concierge Service" /> },
  "concierge-service": { icon: FaConciergeBell, label: <FormattedMessage id="amenity.conciergeService" defaultMessage="Concierge Service" /> },
  "covered-parking": { icon: FaParking, label: <FormattedMessage id="amenity.coveredParking" defaultMessage="Covered Parking" /> },
  "shared-gym": { icon: FaDumbbell, label: <FormattedMessage id="amenity.sharedGym" defaultMessage="Shared Gym" /> },
  "walk-in-closet": { icon: FaDoorOpen, label: <FormattedMessage id="amenity.walkInCloset" defaultMessage="Walk-in Closet" /> },
  "sea-water-view": { icon: FaWater, label: <FormattedMessage id="amenity.viewOfWater" defaultMessage="Sea/Water View" /> },
  "view-of-water": { icon: FaWater, label: <FormattedMessage id="amenity.viewOfWater" defaultMessage="Sea/Water View" /> },
  "lobby-in-building": { icon: FaBuilding, label: <FormattedMessage id="amenity.lobbyInBuilding" defaultMessage="Lobby in Building" /> },
  "bbq-area": { icon: FaFire, label: <FormattedMessage id="amenity.bbqArea" defaultMessage="BBQ Area" /> },
  "barbecue-area": { icon: FaFire, label: <FormattedMessage id="amenity.bbqArea" defaultMessage="BBQ Area" /> },
  "pets-allowed": { icon: FaDog, label: <FormattedMessage id="amenity.petsAllowed" defaultMessage="Pets Allowed" /> },
  "city-view": { icon: FaCity, label: <FormattedMessage id="amenity.cityView" defaultMessage="City View" /> },
  "community-view": { icon: FaStreetView, label: <FormattedMessage id="amenity.communityView" defaultMessage="Community View" /> },
  "drivers-room": { icon: FaUserFriends, label: <FormattedMessage id="amenity.driversRoom" defaultMessage="Driver's Room" /> },
  "fully-fitted-kitchen": { icon: FaUtensils, label: <FormattedMessage id="amenity.fullyFittedKitchen" defaultMessage="Fully Fitted Kitchen" /> },
  "golf-view": { icon: FaTree, label: <FormattedMessage id="amenity.golfView" defaultMessage="Golf View" /> },
  "heating": { icon: FaFire, label: <FormattedMessage id="amenity.heating" defaultMessage="Heating" /> },
  "indoor-swimming-pool": { icon: FaSwimmingPool, label: <FormattedMessage id="amenity.indoorSwimmingPool" defaultMessage="Indoor Swimming Pool" /> },
  "on-low-floor": { icon: FaBuilding, label: <FormattedMessage id="amenity.onLowFloor" defaultMessage="On Low Floor" /> },
  "near-golf": { icon: FaChess, label: <FormattedMessage id="amenity.nearGolf" defaultMessage="Near Golf" /> },
  "near-mosque": { icon: FaMosque, label: <FormattedMessage id="amenity.nearMosque" defaultMessage="Near Mosque" /> },
  "near-metro": { icon: FaSubway, label: <FormattedMessage id="amenity.nearMetro" defaultMessage="Near Metro" /> },
  "north-orientation": { icon: FaCompass, label: <FormattedMessage id="amenity.northOrientation" defaultMessage="North Orientation" /> },
  "near-school": { icon: FaShoppingCart, label: <FormattedMessage id="amenity.nearSchool" defaultMessage="Near School" /> },
  "private-garage": { icon: FaCar, label: <FormattedMessage id="amenity.privateGarage" defaultMessage="Private Garage" /> },
  "spa": { icon: FaSpa, label: <FormattedMessage id="amenity.spa" defaultMessage="Spa" /> },
  "study": { icon: FaPenFancy, label: <FormattedMessage id="amenity.study" defaultMessage="Study" /> },
  "terrace": { icon: FaTree, label: <FormattedMessage id="amenity.terrace" defaultMessage="Terrace" /> },
  "within-a-compound": { icon: FaBuilding, label: <FormattedMessage id="amenity.withinaCompound" defaultMessage="Within a Compound" /> },
  "basement-parking": { icon: FaParking, label: <FormattedMessage id="amenity.basementParking" defaultMessage="Basement Parking" /> },
  "garden-view": { icon: FaCar, label: <FormattedMessage id="amenity.gardenView" defaultMessage="Garden View" /> },
  "near-public-transportation": { icon: FaSubway, label: <FormattedMessage id="amenity.nearPublicTransportation" defaultMessage="Near Public Transportation" /> },
  "office-partitions": { icon: FaBuilding, label: <FormattedMessage id="amenity.officePartitions" defaultMessage="Office Partitions" /> },
  "on-high-floor": { icon: FaBuilding, label: <FormattedMessage id="amenity.onHighFloor" defaultMessage="On High Floor" /> },
  "public-parks": { icon: FaLeaf, label: <FormattedMessage id="amenity.publicParks" defaultMessage="Public Parks" /> },
  "basement": { icon: FaBuilding, label: <FormattedMessage id="amenity.basement" defaultMessage="Basement" /> },
  "beach-access": { icon: FaUmbrellaBeach, label: <FormattedMessage id="amenity.beachAccess" defaultMessage="Beach Access" /> },
  "near-airport": { icon: FaPlane, label: <FormattedMessage id="amenity.nearAirport" defaultMessage="Near Airport" /> },
  "near-hospital": { icon: FaHospital, label: <FormattedMessage id="amenity.nearHospital" defaultMessage="Near Hospital" /> },
  "near-restaurant": { icon: FaUtensils, label: <FormattedMessage id="amenity.nearRestaurant" defaultMessage="Near Restaurant" /> },
  "near-veterinary": { icon: FaDog, label: <FormattedMessage id="amenity.nearVeterinary" defaultMessage="Near Veterinary" /> },
  "private-garden": { icon: FaLeaf, label: <FormattedMessage id="amenity.privateGarden" defaultMessage="Private Garden" /> },
  "private-gym": { icon: FaDumbbell, label: <FormattedMessage id="amenity.privateGym" defaultMessage="Private Gym" /> },
  "steam-room": { icon: FaHotTub, label: <FormattedMessage id="amenity.steamRoom" defaultMessage="Steam Room" /> },
  "storage-room": { icon: FaBox, label: <FormattedMessage id="amenity.storageRoom" defaultMessage="Storage Room" /> },
  "upgraded-interior": { icon: FaBrush, label: <FormattedMessage id="amenity.upgradedInterior" defaultMessage="Upgraded Interior" /> },
  "pantry": { icon: FaCoffee, label: <FormattedMessage id="amenity.pantry" defaultMessage="Pantry" /> },
  "private-pool": { icon: FaSwimmingPool, label: <FormattedMessage id="amenity.privatePool" defaultMessage="Private Pool" /> },
  "kitchen-appliances": { icon: FaBlender, label: <FormattedMessage id="amenity.kitchenAppliances" defaultMessage="Kitchen Appliances" /> },
  "sauna": { icon: FaHotTub, label: <FormattedMessage id="amenity.sauna" defaultMessage="Sauna" /> },
  "reception-area": { icon: FaConciergeBell, label: <FormattedMessage id="amenity.receptionArea" defaultMessage="Reception Area" /> },
  "gazebo": { icon: GiWoodCabin, label: <FormattedMessage id="amenity.gazebo" defaultMessage="Gazebo" /> },
  "maid-service": { icon: MdCleaningServices, label: <FormattedMessage id="amenity.maidService" defaultMessage="Maid Service" /> },
  "childrens-play-area": { icon: FaChild, label: <FormattedMessage id="amenity.childrensPlayArea" defaultMessage="Children's Play Area" /> },
  "kids-play-area": { icon: FaChild, label: <FormattedMessage id="amenity.childrensPlayArea" defaultMessage="Children's Play Area" /> },
};

const PropertyInfo = ({ property }) => {
  const intl = useIntl();
  const { isOpen, onToggle } = useDisclosure();
  const [isExpanded, setIsExpanded] = useState(false);

  const initialAmenities = property?.amenities?.slice(0, 6) || [];
  const remainingAmenities = property?.amenities?.slice(6) || [];

  const CHARACTER_LIMIT = 400;
  const description = intl.locale === "ar" && property?.description_ar ? property?.description_ar : property?.description_en;

  const title = intl.locale === "ar" && property?.title_ar ? property?.title_ar : property?.title_en;

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };
  console.log(initialAmenities, "initialAmenities")

  return (
    <Box p={{ base: 4, md: 6 }} maxW="1200px" mx="auto">
      <Stack spacing={{ base: 6, md: 8 }}>
        <Box borderBottom="1px solid" borderColor="gray.200" pb={{ base: 6, md: 8 }}>
          <Heading fontSize={{ base: "2xl", md: "4xl" }} fontWeight="bold" overflowWrap="break-word" wordBreak="break-word">
            {title}
          </Heading>
        </Box>
        <Box borderBottom="1px solid" borderColor="gray.200" pb={{ base: 6, md: 8 }}>
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 4, md: 6 }}>
            <Flex align="center">
              <Icon as={TbCurrencyDirham} boxSize={{ base: 8, md: 10 }} mr={2} />
              <Text fontSize={{ base: "xl", md: "2xl" }}>
                AED {property?.price}
                {property?.rental_period && (
                  <Text as="span" fontSize={{ base: "lg", md: "xl" }}>
                    <span> / </span>
                    {property?.rental_period === "yearly" && (
                      <FormattedMessage id="property.rentalPeriod.yearly" defaultMessage="Yearly" />
                    )}
                    {property?.rental_period === "monthly" && (
                      <FormattedMessage id="property.rentalPeriod.monthly" defaultMessage="Monthly" />
                    )}
                    {property?.rental_period === "weekly" && (
                      <FormattedMessage id="property.rentalPeriod.weekly" defaultMessage="Weekly" />
                    )}
                    {property?.rental_period === "daily" && (
                      <FormattedMessage id="property.rentalPeriod.daily" defaultMessage="Daily" />
                    )}
                  </Text>
                )}
              </Text>
            </Flex>
            <Flex align="center">
              <Icon as={FaLocationArrow} boxSize={{ base: 6, md: 8 }} mr={2} />
              <Text fontSize={{ base: "md", md: "lg" }}>
                {property?.tower_name}{property?.tower_name && ","} {property?.sub_locality}{property?.sub_locality && ","} {property?.community}{property?.community && ","} {property?.city}
              </Text>
            </Flex>
          </SimpleGrid>

          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 4, md: 6 }} mt={6}>
            <Flex align="center">
              <Icon as={FaBuilding} boxSize={{ base: 6, md: 8 }} mr={2} />
              <Text fontSize={{ base: "md", md: "lg" }}>
                {property?.property_type === "AP" && <FormattedMessage id="property.apartment" defaultMessage="Apartment" />}
                {property?.property_type === "DX" && <FormattedMessage id="property.duplex" defaultMessage="Duplex" />}
                {property?.property_type === "PH" && <FormattedMessage id="property.penthouse" defaultMessage="Penthouse" />}
                {property?.property_type === "TH" && <FormattedMessage id="property.townhouse" defaultMessage="Townhouse" />}
                {property?.property_type === "VH" && <FormattedMessage id="property.villa" defaultMessage="Villa" />}
                {property?.property_type === "SH" && <FormattedMessage id="property.shortTermHotelApartment" defaultMessage="ShortTermHotelApartment" />}
                {property?.property_type === "OF" && <FormattedMessage id="property.officeSpace" defaultMessage="OfficeSpace" />}
                {property?.property_type === "SR" && <FormattedMessage id="property.showroom" defaultMessage="ShowRoom" />}
                {" "}
                <FormattedMessage id="property.for" defaultMessage="for" />
                {" "}
                {property?.property_purpose?.toLowerCase() === "rent" && <FormattedMessage id="property.purpose.rent" defaultMessage="Rent" />}
                {property?.property_purpose?.toLowerCase() === "sale" && <FormattedMessage id="property.purpose.sale" defaultMessage="Sale" />}
                {property?.property_purpose?.toLowerCase() !== "rent" && property?.property_purpose?.toLowerCase() !== "sale" && property?.property_purpose}
              </Text>
            </Flex>
            <Flex align="center">
              <Icon as={FaEye} boxSize={{ base: 6, md: 8 }} mr={2} />
              <Text fontSize={{ base: "md", md: "lg" }}>
                <FormattedMessage id="property.views" defaultMessage="Views:" /> {property?.viewsCount}
              </Text>
            </Flex>
          </SimpleGrid>
        </Box>
        <Box borderBottom="1px solid" borderColor="gray.200" pb={{ base: 6, md: 8 }}>
          <Heading fontSize={{ base: "xl", md: "2xl" }} mb={4}>
            <FormattedMessage id="property.details" defaultMessage="Property Details" />
          </Heading>
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: 4, md: 6 }}>
            {property?.property_type !== "OF" && (
              <Flex align="center">
                <Icon as={FaBed} boxSize={{ base: 6, md: 8 }} mr={2} />
                <Text fontSize={{ base: "md", md: "lg" }}>
                  {property?.bedroom}{" "}
                  <FormattedMessage
                    id={Number(property?.bedroom) === 1 ? "property.bedroom" : "property.bedrooms"}
                    defaultMessage={Number(property?.bedroom) === 1 ? "Bedroom" : "Bedrooms"}
                  />
                </Text>
              </Flex>
            )}
            <Flex align="center">
              <Icon as={FaBath} boxSize={{ base: 6, md: 8 }} mr={2} />
              <Text fontSize={{ base: "md", md: "lg" }}>
                {property?.bathroom}{" "}
                <FormattedMessage
                  id={Number(property?.bathroom) === 1 ? "property.bathroom" : "property.bathrooms"}
                  defaultMessage={Number(property?.bathroom) === 1 ? "Bathroom" : "Bathrooms"}
                />
              </Text>
            </Flex>
            <Flex align="center">
              <Icon as={FaBuilding} boxSize={{ base: 6, md: 8 }} mr={2} />
              <Text fontSize={{ base: "md", md: "lg" }}>
                {property?.size} <FormattedMessage id="property.sqft" defaultMessage="SQFT" />
              </Text>
            </Flex>
          </SimpleGrid>

          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: 4, md: 6 }} mt={6}>
            <Flex align="center">
              <Icon as={FaClipboardCheck} boxSize={{ base: 6, md: 8 }} mr={2} />
              <Text fontSize={{ base: "md", md: "lg" }}>
                <FormattedMessage id="property.purpose" defaultMessage="Purpose" />{": "}
                {property?.property_purpose?.toLowerCase() === "rent" && <FormattedMessage id="property.purpose.rent" defaultMessage="Rent" />}
                {property?.property_purpose?.toLowerCase() === "sale" && <FormattedMessage id="property.purpose.sale" defaultMessage="Sale" />}
                {property?.property_purpose?.toLowerCase() !== "rent" && property?.property_purpose?.toLowerCase() !== "sale" && property?.property_purpose}
              </Text>
            </Flex>
            <Flex align="center">
              <Icon as={FaCouch} boxSize={{ base: 6, md: 8 }} mr={2} />
              <Text fontSize={{ base: "md", md: "lg" }}>
                {property?.furnished === "furnished" && (
                  <FormattedMessage id="property.furnished.furnished" defaultMessage="Furnished" />
                )}
                {property?.furnished === "unfurnished" && (
                  <FormattedMessage id="property.furnished.unfurnished" defaultMessage="Unfurnished" />
                )}
                {property?.furnished === "semi-furnished" && (
                  <FormattedMessage id="property.furnished.semi-furnished" defaultMessage="Semi-Furnished" />
                )}
              </Text>
            </Flex>
            {property?.cheques && (
              <Flex align="center">
                <Icon as={FaCreditCard} boxSize={{ base: 6, md: 8 }} mr={2} />
                <Text fontSize={{ base: "md", md: "lg" }}>
                  <FormattedMessage id="property.cheques" defaultMessage="Cheques:" />{" "}
                  {property?.cheques}
                </Text>
              </Flex>
            )}
            {property?.rental_period && (
              <Flex align="center">
                <Icon as={FaClipboardCheck} boxSize={{ base: 6, md: 8 }} mr={2} />
                <Text fontSize={{ base: "md", md: "lg" }}>
                  <FormattedMessage id="property.rentalPeriod.label" defaultMessage="Rental Period:" />{" "}
                  {property?.rental_period === "yearly" && <FormattedMessage id="property.rentalPeriod.yearly" defaultMessage="Yearly" />}
                  {property?.rental_period === "monthly" && <FormattedMessage id="property.rentalPeriod.monthly" defaultMessage="Monthly" />}
                  {property?.rental_period === "weekly" && <FormattedMessage id="property.rentalPeriod.weekly" defaultMessage="Weekly" />}
                  {property?.rental_period === "daily" && <FormattedMessage id="property.rentalPeriod.daily" defaultMessage="Daily" />}
                </Text>
              </Flex>
            )}
            {property?.category && (
              <Flex align="center">
                <Icon as={FaHome} boxSize={{ base: 6, md: 8 }} mr={2} />
                <Text fontSize={{ base: "md", md: "lg" }}>
                  <FormattedMessage id="property.category" defaultMessage="Category" />{': '}
                  {property?.category?.toLowerCase() === "residential" && <FormattedMessage id="property.category.residential" defaultMessage="Residential" />}
                  {property?.category?.toLowerCase() === "commercial" && <FormattedMessage id="property.category.commercial" defaultMessage="Commercial" />}
                  {property?.category?.toLowerCase() !== "residential" && property?.category?.toLowerCase() !== "commercial" && property?.category}
                </Text>
              </Flex>
            )}
          </SimpleGrid>

          {property?.compliance && (
            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: 4, md: 6 }} mt={6}>
              {property?.compliance?.issuingClientLicenseNumber && (
                <Flex align="center">
                  <Icon as={FaCreditCard} boxSize={{ base: 6, md: 8 }} mr={2} />
                  <Text fontSize={{ base: "md", md: "lg" }}>
                    <FormattedMessage id="property.compliance.licenseNumber" defaultMessage="License No:" />{" "}
                    {property?.compliance?.issuingClientLicenseNumber}
                  </Text>
                </Flex>
              )}
              {property?.compliance?.listingAdvertisementNumber && (
                <Flex align="center">
                  <Icon as={FaClipboardCheck} boxSize={{ base: 6, md: 8 }} mr={2} />
                  <Text fontSize={{ base: "md", md: "lg" }}>
                    <FormattedMessage id="property.compliance.adNumber" defaultMessage="Ad No:" />{" "}
                    {property?.compliance?.listingAdvertisementNumber}
                  </Text>
                </Flex>
              )}
            </SimpleGrid>
          )}
        </Box>
        <Box borderBottom="1px solid" borderColor="gray.200" pb={{ base: 6, md: 8 }}>
          <Heading fontSize={{ base: "xl", md: "2xl" }} mb={4}>
            <FormattedMessage id="property.description" defaultMessage="Property Description" />
          </Heading>
          {isExpanded ? (
            <Box
              fontSize={{ base: "sm", md: "md" }}
              overflowWrap="break-word"
              wordBreak="break-word"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          ) : (
            <Box>
              <Box
                fontSize={{ base: "sm", md: "md" }}
                overflowWrap="break-word"
                wordBreak="break-word"
                dangerouslySetInnerHTML={{ __html: description?.slice(0, CHARACTER_LIMIT) }}
              />
              {description?.length > CHARACTER_LIMIT && "..."}
            </Box>
          )}
          <Button
            onClick={toggleExpanded}
            variant="link"
            colorScheme="blue"
            mt={2}
            fontSize={{ base: "sm", md: "md" }}
            _hover={{ textDecoration: 'underline' }}
          >
            {isExpanded ? (
              <FormattedMessage id="see_less_description" defaultMessage="See Less Description" />
            ) : (
              <FormattedMessage id="see_full_description" defaultMessage="See full Description" />
            )}
          </Button>
        </Box>

        <Box mb={8}>
          <Grid templateColumns={{ base: "repeat(2, 1fr)", md: "repeat(4, 1fr)" }} gap={6}>
            {initialAmenities.map((amenity, index) => {
              const amenityData = amenitiesMapping[amenity];
              if (!amenityData) return null;
              return (
                <Flex key={index} direction="column" align="center" textAlign={{ base: "center", md: "start" }}>
                  <Icon as={amenityData?.icon} boxSize={10} mb={2} />
                  <Text fontSize="lg" textAlign="center">{amenityData?.label}</Text>
                </Flex>
              );
            })}
            {isOpen && remainingAmenities.map((amenity, index) => {
              const amenityData = amenitiesMapping[amenity];
              if (!amenityData) return null;
              return (
                <Flex key={index} direction="column" align="center" textAlign={{ base: "center", md: "start" }}>
                  <Icon as={amenityData?.icon} boxSize={10} mb={2} />
                  <Text fontSize="lg" textAlign="center">{amenityData?.label}</Text>
                </Flex>
              );
            })}
          </Grid>

          <Collapse in={isOpen} animateOpacity>
          </Collapse>

          {remainingAmenities?.length > 0 && (
            <Box mt={6} textAlign="center">
              <Button
                onClick={onToggle}
                size={{ base: "md", md: "lg" }}
                variant="outline"
              >
                {isOpen ? (
                  <FormattedMessage id="property.showLess" defaultMessage="Show Less" />
                ) : (
                  <FormattedMessage id="property.showMore" defaultMessage="Show More" />
                )}
              </Button>
            </Box>
          )}
        </Box>
      </Stack>
    </Box>
  );
};

export default PropertyInfo;